/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Skills_LegendInputs */



/**
* | output |
* | --- |
* | "Integrations marked with a lightning bolt come with skills: the assistant can act through them directly in chat." |
*
* @param {Integrations_Skills_LegendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_skills_legend = /** @type {((inputs?: Integrations_Skills_LegendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Skills_LegendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit einem Blitz markierte Integrationen bringen Skills mit: Der Assistent kann über sie direkt im Chat handeln.")
	return /** @type {LocalizedString} */ ("Integrations marked with a lightning bolt come with skills: the assistant can act through them directly in chat.")
});